import $ from 'jquery';
import tippy from 'tippy.js';

const $clickButton = $( '.js-copy-link' );

if ( $clickButton && $clickButton.length ) {
	const tippyInstance = tippy(
		$clickButton[0],
		{
			content: 'Copied!',
			trigger: 'manual',
		}
	);

	$clickButton.on( 'click', function(e) {
		e.preventDefault();

		const textToCopy = $clickButton.closest( '.js-copy-wrapper' ).find('.js-copy-text').text();

		if ( textToCopy ) {
			navigator.clipboard.writeText(textToCopy).then(function() {
				tippyInstance.show();
			}, function(err) {
			});
		}
	} );
}
